<div class="chart-container">
  <canvas baseChart
    [type]="'line'"
    [datasets]="datasets()"
    [labels]="labels()"
    [options]="chartOptions()"
    [plugins]="chartPlugins">
  </canvas>
</div>
